import { InjectionToken } from '@angular/core';
import { Y42Route } from './y42-router.model';

export const Y42_ROUTE = new InjectionToken<Y42Route>('Y42 Route');
